<!-- This is part of outdated page https://usd.textbooksatcost.com/service/help_desk.php > "Selling questions" -->
<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I sold a book</h1>
			<v-base-nav-page :links="links" :nosearch="true">
			</v-base-nav-page>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import BaseNavPage from './../components/BaseNavPage';
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "SalesQuestions",

		components: {
			BaseNavLinks,
			'v-base-nav-page': BaseNavPage,
		},

		data() {
			const self = this;

			return {
				links: [
					{
						to: '/when_will_i_receive_payment/' + parseInt(self.$route.params.item_id),
						caption: 'When will I receive payment?'
					},
					{
						to: '/manage_label/' + parseInt(self.$route.params.item_id),
						caption: 'How do I manage my shipping label?'
					},
					{
						url: '/seller/seller-payment.php',
						caption: 'Do I get paid for shipping?'
					},
					{
						to: '/can_cancel_sale/' + parseInt(self.$route.params.item_id),
						caption: 'Can I cancel a sale?'
					},
					{
						to: '/vacation/' + parseInt(self.$route.params.item_id),
						caption: 'How do I go on vacation hold?'
					},
					{
						to: '/volume_sellers/' + parseInt(self.$route.params.item_id),
						caption: 'Do you offer special tools for volume sellers?'
					},
					{
						to: '/why_on_hold/' + parseInt(self.$route.params.item_id),
						caption: 'Why is my payment on hold?'
					},
				]
			}
		},

		mounted() {
			const self = this;
		}
	}
</script>

<style scoped>

</style>
